import { type VisitStoredFilters } from "./types";

export const CARE_TYPES = [
  "Dementia",
  "IV",
  "PICC Line",
  "TPN",
  "Trache",
  "Wound Care",
  "Wound Vac",
] as const;

export const VISIT_TYPE_LABELS: Record<string, string> = {
  ADMISSION: "Admission",
  ADMISSION_AND_FIRST_VISIT: "Admission & First Visit",
  DISCHARGE: "Discharge",
  EVALUATION: "Evaluation",
  NURSING_EVAL: "Nursing Eval",
  RECERTIFICATION: "Recertification",
  REGULAR: "Routine",
  RESUMPTION_OF_CARE: "Resumption",
  SUPERVISORY: "Supervisory",
} as const;

export const VISIT_TYPE_ENTRIES = Object.entries(VISIT_TYPE_LABELS).toSorted(([, a], [, b]) =>
  a.localeCompare(b)
);

export const SHIFT_ROLES = ["Caregiver", "CHHA", "CNA", "LVN", "RN"] as const;

export const VISITS_PER_WEEK_MAX = 7;

export const VISIT_FILTERS_LOCAL_STORAGE_KEY = "in-home-visits-filters";

export const DEFAULT_STORED_FILTERS: VisitStoredFilters = {
  shiftRoles: [],
  excludedCareTypes: [],
  visitTypes: [],
  payMinimum: undefined,
  visitsPerWeekMaximum: undefined,
};
